var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-2"},[_c('button',{staticClass:"btn btn-danger my-auto",on:{"click":_vm.productDelete}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }